import { Box, Container, Stack, Typography } from "@mui/material";
import thankyoupage from "../../assets/img/thankyoupage.png";
import { getColor } from "../../style/color/color";
import ACRButton from "../../commanComponents/ACRButton";
import { useNavigate } from "react-router-dom";
import { fonts } from "../../style/fonts/fonts";

function ThankYouPage(props) {
  const navigation = useNavigate();

  return (
    <Container>
      <Stack
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "start",
          mt: { xs: "50%", md: "30%" },
          position: "relative",
        }}
      >
        <img
          src={thankyoupage}
          alt=""
          style={{
            width: "100%",
            maxWidth: "400px",
            objectFit: "contain",
          }}
        />
        <Typography
          variant="h6"
          sx={{
            width: "180px",
            position: "absolute",
            top: -30,
            left: -10,
            bottom: 2,
            ml: "30px",
            padding: "5px",
            color: getColor.SecondaryMidnightBlue,
            fontSize: 25,
            fontFamily: fonts.manrope,
            fontWeight: "800",
          }}
        >
          Thank You for Your Trust
        </Typography>
        <Typography
          variant="h6"
          sx={{
            width: "280px",
            position: "absolute",

            bottom: -20,
            right: -10,
            textAlign: "right",
            padding: "5px",
            color: getColor.SecondaryMidnightBlue,
            fontSize: 16,
            fontFamily: fonts.manrope,
            fontWeight: "500",
          }}
        >
          Your Personalised Financial Dashboard Awaits.
        </Typography>
      </Stack>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          mt: "40%",
        }}
      >
        <ACRButton
          label={"Check your details"}
          style={{
            width: "100%",
            maxWidth: "350px",
            backgroundColor: getColor.primaryOrange,
            color: getColor.PrimaryWhite,
            borderRadius: "40px",
            p: "10px",
            mb: "20px",
            height: "60px",
            lineHeight: "22.2px",
            fontWeight: 700,
            fontSize: "16px",
            textAlign: "center",
            textTransform: "initial",
          }}
          onClickButton={() => {
            navigation("/financialsnapshot");
          }}
        />
      </Box>
    </Container>
  );
}

export default ThankYouPage;
